export default __webpack_public_path__ + "static/media/Swap.178275ed.png";